/* eslint-disable no-underscore-dangle */
import { throwOnError } from './utils';

type GetCheckResponse = {
  id: string;
  amount: number | null;
  money_amount: number | null;
  point_amount: number | null;
  note: string | null;
  description: string | null;
  is_onetime: boolean;
  is_disabled: boolean;
  status: 'not-started' | 'valid' | 'paused' | 'usage-limit-reached' | 'expired';
  token: string;
  created_at: string;
  expires_at: string;
  starts_at: string | null;
  last_used_at: string | null;
  usage_count: number;
  usage_limit: number;
  point_expires_at: string;
  point_expires_in_days: number | null;
  org_name: string;
  private_money: {
    name: string;
  };
  user: {
    name: string;
  };
  bear_point_shop?: {
    id: string;
    is_merchant: boolean;
    name: string;
  };
  additional_private_moneys?: {
    name: string;
  }[];
  serial_code?: string | null;
};

export const getChecks = (params = '') =>
  fetch(`/api/checks?${params}`, {
    method: 'GET',
    credentials: 'same-origin',
    headers: {
      'content-type': 'application/json',
    },
  }).then(throwOnError);

export const getCheck = (uuid: string) =>
  fetch(`/api/checks/${uuid}`, {
    method: 'GET',
    credentials: 'same-origin',
    headers: {
      'content-type': 'application/json',
    },
  }).then(throwOnError<GetCheckResponse>);

export const updateCheck = (uuid: string, params: Record<string, unknown> = {}) =>
  fetch(`/api/checks/${uuid}`, {
    method: 'PATCH',
    credentials: 'same-origin',
    headers: {
      'content-type': 'application/json',
    },
    body: JSON.stringify({ ...params, _csrf_token: window._csrf_token }),
  }).then(throwOnError);

export const createCheck = (params: Record<string, unknown> = {}) =>
  fetch('/api/checks', {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'content-type': 'application/json',
    },
    body: JSON.stringify({ ...params, _csrf_token: window._csrf_token }),
  }).then(throwOnError);

export const bulkCreateChecks = async ({
  name,
  descripton,
  csv,
  signal,
}: {
  name: string;
  descripton: string;
  csv: File;
  signal?: AbortSignal;
}) => {
  const formData = new FormData();
  formData.append('name', name);
  formData.append('description', descripton);
  formData.append('csv', csv);
  formData.append('_csrf_token', window._csrf_token);

  return fetch('/api/bulk-checks', {
    method: 'POST',
    credentials: 'same-origin',
    body: formData,
    signal,
  }).then(throwOnError);
};
